import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { getCachedSession } from "../auth/client";
import { safeRedirectPath } from "../utils/redirect";

/**
 * Unauthenticated shell guard for login/register routes.
 * Contract: sanitize redirect targets and send authenticated users
 * back into the app without rendering child auth screens.
 */
export const Route = createFileRoute("/_unauthenticated")({
  validateSearch: z.object({
    redirect: z.string().optional().transform(safeRedirectPath),
  }),
  beforeLoad: async ({ search }) => {
    const { data } = await getCachedSession();
    if (data) {
      throw redirect({ to: search.redirect });
    }
  },
});
